import React, {Component} from 'react'
import {
  MainHeader,
    MainFooter
} from './index'
import {
    Redirect,
    Route,
    Switch
} from 'react-router-dom'
import {connect} from "react-redux";
import routes from "../../routes";


const loading = (
    <div className="spinner-border text-primary m-auto" role="status">
        <span className="sr-only">Chargement...</span>
    </div>
);

class MainLayout extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        console.log("MainLayout:render", this.props);
        // const { user } = this.props;
        //
        // if (user == null) {
        //     return <Redirect to="/login" />;
        // }

        return (
            <>
                <MainHeader/>
                <div className="">
                    <React.Suspense fallback={loading}>
                        <Switch>
                            {routes.map((route, idx) => {
                                return route.component && (
                                    <Route
                                        key={idx}
                                        path={route.path}
                                        exact={route.exact}
                                        name={route.name}
                                        render={props => (
                                            <route.component {...props} />
                                        )} />
                                )
                            })}
                            <Redirect from="/" to="/dashboard" />
                        </Switch>
                    </React.Suspense>
                </div>
                <MainFooter/>
            </>);
    }
}


function mapStateToProps(state) {
    console.log("MainLayout:mapStateToProps", state);
    const { user } = state.auth;
    return {
        user
    };
}

export default connect(mapStateToProps)(MainLayout);
// export default TheLayout;
